import React, { useEffect, useState } from "react";
import CustomInputText from "./CustomInputText";
import MDButton from "./MDButton";
import CustomImageUploader from "./CustomImageUploader";
import MDBox from "./MDBox";
import MDInput from "./MDInput";
import { AddPinCall, DeletePinCall, EditPinCall } from "../redux/api/title.api";
import { basicURL } from "../apiManager/APIConfig";
import { store } from "../redux/store";
import axios from "axios";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Icon from "@mui/material/Icon";

const CustomDrawer = ({ fetchSlide, lang, slide_id, data, open, toggleDrawer }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(data?.files?.[0]?.url);
  const [showLoader, setShowLoader] = useState(false);
  const auth = store.getState().auth || {};
  const authId = auth?.id || null;
  const role = auth?.role;

  const isExisting = !!data?.id;
  const isOwner = data?.owner_id && authId && data.owner_id === authId;
  const canEdit = !isExisting || isOwner;

  useEffect(() => {
    // const extractedTitle = data?.pinLocalizations?.filter((e) => e.field === "title");
    // const extractedBody = data?.pinLocalizations?.filter((e) => e.field === "body");
    setTitle(data?.title);
    setDescription(data?.body);
  }, [data]);

  const onChangeTitle = (e) => {
    setTitle(e.target.value); // Update password state
  };

  const onChangeDescription = (e) => {
    setDescription(e.target.value); // Update password state
  };
  const canUploadFiles =
    data?.id && role !== "prof" && role !== "professor" && role !== "university_admin";

  const handlePhotoMaterial = async (file) => {
    setImage(file);

    if (file) {
      try {
        setShowLoader(true);
        // Handle `.zip` file upload
        const formdata = new FormData();
        formdata.append("file", file);
        formdata.append("entity_type", "pin");
        formdata.append("entity_id", data?.id);
        formdata.append("destination", "pins");
        formdata.append("folder_name", "pins");

        const access_token = store.getState().auth?.access_token;
        let myHeaders = new Headers();
        myHeaders.append("Authorization", access_token);

        myHeaders = {
          Authorization: access_token,
        };

        const response = await axios.post(`${basicURL}/file/upload`, formdata, {
          headers: myHeaders,
          onUploadProgress: (progressEvent) => {
            // Calculate the progress percentage
            const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            // setUploadPercentage(percent);
          },
        });
        setShowLoader(false);
        // setImage(`${basicURL}/${response?.data?.extracted_files?.[1]?.path}`);

        console.log(
          "ZIP file uploaded:",
          `${basicURL}/${response?.data?.extracted_files?.[1]?.path}/{z}/{x}/{y}.png`
        );
        window.location.reload();
      } catch (error) {
        console.error("Upload error:", error);
      }
    }
  };

  const save = async () => {
    if (!canEdit) return;

    if (data?.id) {
      const body = {
        id: data?.id,
        title,
        lang,
        type: "his",
        slide_id,
        body: description,
        locations: JSON.stringify({ data }),
      };
      await EditPinCall(body);
    } else {
      const body = {
        title,
        lang,
        type: "his",
        slide_id,
        body: description,
        locations: JSON.stringify({ data }),
      };
      await AddPinCall(body);
    } //fetch
    await fetchSlide();
    window.location.reload();
  };

  const deletePin = async () => {
    if (!canEdit) return;
    const pin_id = data?.id;
    const confirmation = window.confirm(
      "Are you sure you want to delete this pin? if you delete this pin all footage that you uploaded for this specific pin will be removed permanently."
    );
    if (confirmation) {
      await DeletePinCall(pin_id);
      window.location.reload();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => toggleDrawer(false, !isExisting)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {data?.id ? "Edit pin information" : "Add pin information"}
      </DialogTitle>
      <DialogContent dividers>
        <MDBox component="form" role="form" sx={{ mt: 1 }}>
          <MDBox mb={2}>
            <MDInput
              value={title}
              onChange={onChangeTitle}
              type="text"
              label="Title"
              fullWidth
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              onChange={onChangeDescription}
              multiline
              rows={6}
              value={description}
              type="text"
              label="Description"
              fullWidth
            />
          </MDBox>
        </MDBox>
        {data?.id && (
          <CustomImageUploader
            value={image}
            files={data?.files}
            setFile={handlePhotoMaterial}
            setImage={setImage}
            canUpload={canUploadFiles}
          />
        )}
        {!data?.id && (
          <MDBox mt={1} sx={{ fontSize: 13, color: "text.secondary" }}>
            First save the pin title and description. After that you can attach images to it.
          </MDBox>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <MDButton
          disabled={!description && !title}
          color="info"
          variant="contained"
          onClick={save}
        >
          Save
        </MDButton>
        <MDButton
          disabled={!data?.id}
          color="error"
          variant="outlined"
          onClick={deletePin}
        >
          Delete
        </MDButton>
        <MDButton
          variant="outlined"
          color="secondary"
          onClick={() => toggleDrawer(false, !isExisting)}
        >
          Cancel
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export default CustomDrawer;
